// removed by extract-text-webpack-plugin
module.exports = {"body-container":"_3-ntl","bodyContainer":"_3-ntl","veil":"_2NcCs","site-pusher":"_1uG9d","sitePusher":"_1uG9d","site-container":"_3O-nG","siteContainer":"_3O-nG","page-container":"_2GBhn","pageContainer":"_2GBhn"};


//////////////////
// WEBPACK FOOTER
// ./common/components/MainLayout/main-layout.scss
// module id = 488
// module chunks = 0 1